<template>
    <div class="mt-5">
        <h3 class="">{{title ?? ''}}</h3>
        <ul class="nav nav-tabs mt-3">
            <slot name="tabsOptions"></slot>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div v-for="(slot, index) of tabSlots" :key="index" 
                :id="'tab'+slot" role="tabpanel"
                class="tab-pane fade"
                :class="this.activeTab == slot  ? 'show active' : ''">
                <slot :name="slot"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Tabs',
    components: {
    },
    props: {
        tabsSettings: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
    },
    data: () => {
        const testData = true;

        return {
            testData,
        };
    },
    methods: {
    },
    computed: {
        testComputed() {
            return true;
        },
        tabSlots() {
            let { _, tabsOptions, ...tabSlots } = { ...this.$slots };
            return Object.keys(tabSlots);
        },
        activeTab() {
            return this.tabsSettings.activeTab ? this.tabsSettings.activeTab : this.tabSlots[0];
        }
    },
    created() {
        // console.log('Component created');
    },
    mounted() {
        // console.log('Component mounted');
        if(!this.tabsSettings.activeTab) {
            this.tabsSettings.activeTab = this.tabSlots[0];
        }
    },
    watch: {
    }
};
</script>